
import AppContext from "./Global/Context/appContext";
import React, { useEffect, useState } from 'react'
import reducerApp, { initialStateApp } from "./Global/Reducers/reducerApp";
import { GlobalDebug } from "./remove-console";
import AppRoutes from "./routes/AppRoutes";


function App() {
   useEffect(() => {

     GlobalDebug(false); 
  }, []);
  return (
    <>      
    
      <AppContext initialStateApp={initialStateApp} reducerApp={reducerApp} >          
        <AppRoutes />   
      </AppContext>

    </>
  );
}

export default App;
